import api from './api';

export const getAuthenticate = async (LoginObj) => {

    try {

        let resposta = await api.post(`authenticate`,LoginObj);
        let posts = resposta.data;
        return posts;
    } catch (error) {

        return error.response
    }
};
